import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { ScoreCard } from 'components/shared/ScoreCard/ScoreCard'
import { Separator } from 'components/shared/Separator/Separator'
import { EvaluatorCards } from './../../features/EvaluatorCards/EvaluatorCards'
import { TraitScoreCards } from './../../features/TraitScoreCards/TraitScoreCards'

import { InterviewStateContext } from 'components/modules/interview/context'
import { useContext } from 'hooks'
import { percentScore } from 'utils/stringFormat'
import { getTraits } from './model'

import styles from './Aside.module.scss'

export const Aside = () => {
  const state = useContext(InterviewStateContext)!

  const { ebberScores, evaluators, testAverageScore } = state

  return (
    <Box
      align="center"
      className={styles.aside}
      direction="column"
      tagName="aside"
    >
      <ScoreCard
        averageLabel={t`Average test score: ${testAverageScore}`}
        className={styles.tests}
        label={t`Test score`}
        score={percentScore(ebberScores?.['Ebber Test Score'])}
      />
      <TraitScoreCards
        scores={ebberScores}
        traits={getTraits()}
        language={state.user.language}
      />
      <Separator maxWidth="80%" tagName="span" />
      <EvaluatorCards {...{ evaluators }} />
    </Box>
  )
}
